export type AdminNavLabelKey =
  | "dashboard"
  | "articles"
  | "events"
  | "places"
  | "taxonomy"
  | "legal"
  | "users"
  | "feedbacks"
  | "notifications"
  | "team";

export interface AdminNavItem {
  href: string;
  labelKey: AdminNavLabelKey;
  /** When true, only admin staff see the item. */
  adminOnly?: boolean;
}

export const adminNavItems: AdminNavItem[] = [
  { href: "/dashboard", labelKey: "dashboard" },
  { href: "/articles", labelKey: "articles" },
  { href: "/events", labelKey: "events" },
  { href: "/places", labelKey: "places" },
  { href: "/taxonomy", labelKey: "taxonomy" },
  { href: "/legal", labelKey: "legal", adminOnly: true },
  { href: "/users", labelKey: "users", adminOnly: true },
  { href: "/feedbacks", labelKey: "feedbacks", adminOnly: true },
  { href: "/notifications", labelKey: "notifications", adminOnly: true },
  { href: "/team", labelKey: "team", adminOnly: true },
];

export function isAdminNavActive(pathname: string, href: string): boolean {
  if (href === "/dashboard") {
    return pathname === href;
  }

  return pathname === href || pathname.startsWith(`${href}/`);
}
